export default function <T>(keys: (keyof T)[], a: T, b: T): boolean {
  return !keys.find(key => a[key] !== b[key])
}
